<template>
    <label :class="{...{'mt-5': hasMarginTop, 'text-light': color === 'light'}, ...displayClasses}">
        <slot></slot>
    </label>
</template>

<script>
    import displayClassesMixin from "./mixin/displayClassesMixin";

    export default {
        name: "LabelTag",
        mixins: [displayClassesMixin],
        props: {
            hasMarginTop: {
                type: Boolean,
                default: false,
            },
            color: {
                type: String,
            },
        }
    }
</script>
